import SearchInput from "./search-input";

export default SearchInput;
